import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { get, post } from '../../../Model/Network/Config/Axios';
import { KeyValue } from '../Components/KeyValue';
import { PieGraph } from '../fAnalytics';
import Container from '../fAnalytics/Container';
import { Modal } from '../fModal/Modal';
import moment from 'moment';
import { DownloadCsv } from '../../../Utils/Downloader';
import { handleError, showToast } from '../fToast/ToastCallback';


const Allocation = forwardRef(({type,reference,logs,title,currency="INR",onReloadInvoice=()=>{},onEnableEditCostAllocation=undefined,disableEdit=false},ref) => {



    const [loading,setLoading] = useState(true);
    const [data,setData] = useState({});
    const [showChart,setShowChart] = useState(false);
    const [toggleData] = useState('ratio');
    const [viewLogs,setViewLogs] = useState(false);
    const [customFormModal,setCustomFormModal] = useState(null);
    const [deleteAllocationModal,setDeleteAllocationModal] = useState(false);

    const log=(item)=>{
        return (
            <div>
                <KeyValue title='Log' value={(item && item.log)?item.log:""} />
                <KeyValue title='Owner Name' value={(item && item.owner && item.owner.ownerName)?item.owner.ownerName:""} />
                <KeyValue title='Owner ID' value={(item && item.ownerId)?item.ownerId:""} />
                <KeyValue title='Owner Type' value={(item && item.ownerType)?item.ownerType:""} />
                <KeyValue title='Remarks' value={(item && item.remarks)?item.remarks:""} />
                <KeyValue title='Time' value={(item && item.time)?moment(item.time).format("DD-MM-YYYY"):""} />
            </div>
        )
    }
   

    useImperativeHandle(ref,()=>({
        INIT:()=>INIT()
    }))


    let INIT = () => {
        get(`vendor/costAllocation/getAllocations?referenceType=${type}&referenceId=${reference}`,(e,r)=>{
            if(r) {
                setData(r);
                setLoading(false);
            }
        })
    }


    useEffect(()=>{
        get(`vendor/costAllocation/getAllocations?referenceType=${type}&referenceId=${reference}`,(e,r)=>{
            if(r) {
                setData(r);
                setLoading(false);
            }
        })
    },[reference])

    if(loading) {
        return <></>
    }

    let {allocations,baseType,totalAllocatedAmount}= data.data;
    const pieItems = allocations.map(e => e.location);
    const pieData = allocations.map(e => e[toggleData]);


    return(
        <div>
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'baseline'}}>
            <div style={{fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px'}}>{title ? title : "Cost Allocation"}</div>
            {
                logs && logs.length>0 ?<div onClick={()=>{setViewLogs(true)}} style={{fontWeight:'bold',cursor:'pointer', marginLeft:'15rem'}}>Show Logs</div>:null
            }
            <div className="flex flex-v-center" style={{
                    backgroundColor: '#767DFF',
                    height: 22,
                    width: 100,
                    borderRadius: 32,
                    cursor: 'pointer',
                    padding: '0px 3px',
                }}>
                    <div className="flex flex-v-center" style={{ flex: 1, height: '100%' }}>
                        <p onClick={()=> setShowChart(false)} className="flex flex-v-center flex-h-center" style={{
                            flex: 1,
                            textAlign: 'center',
                            fontSize: 11,
                            height: '78%',
                            ...!showChart ? {
                                backgroundColor: '#fff',
                                borderRadius: 32,
                                color: '#767DFF'
                            } : {
                                color: '#fff'
                            }
                        }}>
                            Table
                        </p>
                        <p onClick={() => setShowChart(true)} className="flex flex-v-center flex-h-center" style={{
                            flex: 1,
                            textAlign: 'center',
                            fontSize: 11,
                            height: '78%',
                            ...showChart ? {
                                backgroundColor: '#fff',
                                borderRadius: 32,
                                color: 'var(--active-background)'
                            } : {
                                color: '#fff'
                            }
                        }}>
                            Chart
                        </p>
                    </div>
                </div>
                    {(!disableEdit && data && Object.keys(data).length > 0 && onEnableEditCostAllocation)?<> 
                        <div onClick={()=>{onEnableEditCostAllocation(data)}} style={{cursor: 'pointer', marginLeft: '10px', display: 'inline-flex', alignItems: 'center'}}>
                            <svg style={{fontSize: "18px", color: "var(--text-color)"}} className="bi bi-pencil-square" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                                <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"></path>
                            </svg>
                        </div>
                        <div onClick={()=>{setDeleteAllocationModal(true)}} style={{cursor: 'pointer', marginLeft: '10px', display: 'inline-flex', alignItems: 'center'}}>
                            <svg style={{fontSize: "18px", color: "var(--text-color)"}} className="bi bi-trash" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"></path>
                                <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"></path>
                            </svg>
                        </div>
                    </>:null}
                </div>
            <KeyValue title='Allocation Type' value={baseType} />
            <KeyValue title='Total Allocation Amount' value={totalAllocatedAmount} />
            {!showChart &&
                <div style={{width:'100%',display:'flex',justifyContent:'flex-end'}}>
                    <p
                    onClick={()=>{
                        let base = [['Location','Percentage','Currency','Allocated Amount']];
                        allocations.forEach(item => {
                            let temp = [item.location,item.ratio.toFixed(2),currency,item.amount.toFixed(3)]
                            base.push(temp);
                        });
                        DownloadCsv("costAllocation.csv",base);
                    }}
                    className="btn btn-portlet"
                    style={{
                        width: '98px',
                        fontSize: '9px',
                        padding: '4px 0px',
                        margin: '0 10px 10px 0',
                    }}
                >
                    {"Download Csv"}
                </p>
                    </div>
            }
            {!showChart && <div>
            <div style={{background:'#F9F9FA',height:30,display:'flex',alignItems:'center',width:'100%',border:'1px solid var(--border-color)',borderTopLeftRadius:2,borderTopRightRadius:2}}>
                {
                [
                    {name:'location',style:{flex:2,fontWeight:'bold'}},
                    {name:'Percentage',style:{flex:1,fontWeight:'bold'}},
                    {name:'Currency',style:{flex:1,fontWeight:'bold'}},
                    {name:'Allocated Amount',style:{flex:1,fontWeight:'bold'}},
                  
                ].map((item,index)=>{
                    return(
                        <div key={index} style={{display:'flex',height:30,padding:5,alignItems:'center',borderRight:'1px solid var(--border-color)',...item.style}}>
                            {item.name}
                        </div>
                    )
                })
                }
            </div>

            {
             allocations.map((item,index)=>{
                return(
                    <div key={index} style={{display:'flex',width:'100%',minHeight:35,border:'1px solid var(--border-color)'}}>
                        <div style={{minHeight:35,flex:2,padding:5,display:'flex',flexDirection:'column',borderRight:'1px solid var(--border-color)'}}>
                            {item.location} <br></br>
                            {item && item.budgetId?<div>{item.budgetId}</div>:null}
                            {
                                item && item.customForms && Object.keys(item.customForms).length > 0 ? (
                                    <div style={{fontSize:12}}>
                                        <div style={{paddingTop:5,cursor:'pointer'}} onClick={()=>{
                                            setCustomFormModal({customForms:item.customForms,location:(item && item.location)?item.location:null})
                                        }}>
                                            <h4>Show Custom Form</h4>
                                        </div>
                                    </div>
                                ) : null
                            }
                        </div>
                        <div style={{minHeight:35,flex:1,padding:5,display:'flex',alignItems:'center',borderRight:'1px solid var(--border-color)'}}>{item.ratio ? item.ratio.toFixed(2):item.ratio} %</div>
                        <div style={{minHeight:35,flex:1,padding:5,display:'flex',alignItems:'center',borderRight:'1px solid var(--border-color)'}}>{currency}</div>
                        <div style={{minHeight:35,flex:1,padding:5,display:'flex',alignItems:'center',borderRight:'1px solid var(--border-color)'}}>{item.amount?item.amount.toFixed(3):item.amount}</div>
                    
                    </div>
                )
            })       
            } 
            </div>}  


            {showChart && <Container width="40%" style={{
                    container:{
                        margin:0,
                        marginTop:30
                    }
                }}>
                    <PieGraph
                        textColor="#fff"
                        colors={["#0d6efd","#fd7e14","#20c997","#d63384"]}
                        title={`Cost Allocationasd`}
                        height={350}
                        data={pieData}
                        items={pieItems}
                    />
            </Container> }
            {
                viewLogs?
                    <Modal
                        hideButton={true}
						show={true}
						title="Logs"
						close={() => {
							setViewLogs(false)
						}}
                        modalStyle={{
                            marginRight:'1.5%',

						}}
					>
						{
                            logs.map(log)
                        }
					</Modal>:null
            }

            {
                customFormModal ?
                    <Modal
                        hideButton={true}
                        show={true}
                        title={'Custom Forms'}
                        close={() => {
                            setCustomFormModal(null)
                        }}
                    >
                        <div style={{marginTop:'1rem'}}>
                            {customFormModal && customFormModal.location ? <div style={{fontSize:16,fontWeight:'bold',marginBottom:'2rem'}}>{customFormModal.location}</div> : null}
                            {
                                Object.keys(customFormModal.customForms || {}).map((key,index)=>{
                                    const value = customFormModal.customForms[key];
                                    return (
                                        <KeyValue key={index} title={key} value={value} />
                                    )
                                })
                            }
                        </div>
                    </Modal>
                : null
            }
            {
                deleteAllocationModal && <Modal
                show={true}
                    title="Delete Allocation"
                    des="Are you sure you want to delete the allocation?"
                    close={() => setDeleteAllocationModal(false)}
                    buttonName="Delete"
                    onSave={() => {
                        post(`vendor/costAllocation/removeAllocation`, {
                            invoiceId: reference,
                        }, (e, r) => {
                            if (r) {
                                showToast({
                                    type: 'success',
                                    message: 'Allocation deleted successfully'
                                })
                                onReloadInvoice && onReloadInvoice();
                                setDeleteAllocationModal(false);
                            }
                            else if (e) {
                                handleError(e);
                            }
                        })
                    }}
                />
            }


        </div>
    )
})

Allocation.defaultProps = {
    type:'vendor-invoice',
}

export {Allocation}